import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
	name: 'pubDate',
	standalone: false,
})
export class PubDatePipe implements PipeTransform {
	transform(value: string | number | Date, format = 'MMMM Do YYYY'): string {
		return moment(value, 'YYYYMMDD').format(format);
	}
}
